import * as stylex from "@stylexjs/stylex";
import { useActiveTheme, useRTL } from "hooks";
import { lighten } from "lib/colorManipulator";
import Link from "next/link";
import { FormattedMessage, useIntl } from "react-intl";
import { findArticleAlias, findArticleThemeAlias, getArticleName, subthemesIndex, useAlias } from "routes";
import * as M from "../../materials";
import { breakpoints, colors } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
import { O, pipe } from "../../prelude";
const styles = {
    root: {
        kEafiO: "x178xt8z",
        kPef9Z: "x13fuv20",
        k9WMMc: "x2b8uid",
        $$css: true
    },
    title: {
        kLKAdn: "x1miatn0",
        kGO01o: "x18d9i69 x1ddihdl",
        kGuDYH: "xngnso2",
        kLWn49: "xcgk4ki",
        $$css: true
    }
};
export const RelatedSubthemeArticle = ()=>{
    const alias = useAlias();
    const activeTheme = useActiveTheme();
    const isRTL = useRTL();
    const intl = useIntl();
    const aliasRouteO = findArticleAlias(alias);
    return pipe(aliasRouteO, O.fold(()=>null, (a)=>{
        const articleTheme = findArticleThemeAlias(a);
        const subthemes = subthemesIndex[articleTheme];
        const currentIndex = subthemes.indexOf(a);
        const relatedSubthemeIndex = currentIndex === subthemes.length - 1 ? 0 : currentIndex + 1;
        const relatedArticle = subthemes[relatedSubthemeIndex];
        const styleTheme = M.themes[relatedArticle];
        const imageUrl = styleTheme.kind === "article" ? styleTheme.illustration : null;
        return <M.Grid layout={"home"} // Grid's own baseStyles sets `margin-top: 0 !important` — only another
        // `!important` declaration can outrank that, so it lives in style.global.css,
        // scoped by this marker class (see the comment there for details).
        className="related-subtheme-root" sx={[
            styles.root
        ]} style={{
            borderTopColor: activeTheme.background.light
        }}>
            <h2 {...stylex.props(typography.heading2, styles.title)} style={{
            color: activeTheme.textColor
        }}>
              <FormattedMessage id="Related article" defaultMessage="Related article"/>
            </h2>
            <Link href={`/articles/${relatedArticle}`}>
              <div {...{
            0: {
                className: "x1ypdohk xktia5q x1bpp3o7 x1gesphl xf1e18e xmkeg23 x1y0btm7 x1hhxfu6 x12oqio5 xegeof0 xrdx9lx xzt5al7"
            },
            1: {
                className: "x1ypdohk xktia5q x1bpp3o7 x1gesphl xf1e18e xmkeg23 x1y0btm7 x1hhxfu6 x12oqio5 xegeof0 xrdx9lx xzyj77d"
            }
        }[!!isRTL << 0]} style={{
            color: activeTheme.textColor,
            "--related-subtheme-bg": lighten(activeTheme.background.light, 0.7),
            "--related-subtheme-hover-bg": lighten(activeTheme.background.light, 0.8)
        }}>
                <div className="x78zum5 x1q0g3np x6s0dn4">
                  {imageUrl && <img {...{
            0: {
                className: "x1fu8urw x2sfjvx x1b5akj9 x1n08ycp x1a3imcw xj3b58b x1uso4ew xl010v5 xv61e92"
            },
            1: {
                className: "x1fu8urw x2sfjvx x1b5akj9 x1n08ycp x1a3imcw x1iog12x x1uso4ew x1yf7rl7 xv61e92"
            }
        }[!!isRTL << 0]} src={imageUrl} alt=""/>}

                  <div {...{
            0: {
                className: "xj3b58b x1o6q14k xdpxx8g"
            },
            1: {
                className: "xq1n1xh x1yf7rl7 x1hr2gdg"
            }
        }[!!isRTL << 0]}>
                    <span {...stylex.props(typography.body2)}>
                      <FormattedMessage id="Sub-theme" defaultMessage="Sub-theme"/>
                    </span>
                    <h3 {...stylex.props(typography.body1)}>{getArticleName(intl, relatedArticle)}</h3>
                  </div>
                </div>
              </div>
            </Link>
          </M.Grid>;
    }));
};
